module.exports = function(options) {
  //
  //   Private Vars
  //
  //////////////////////////////////////////////////////////////////////

  const self = {
    activeClass: 'is-active',
    transitionSpeed: 250,
    traverseMax: 2,
    traverseCount: 0
  };


  //
  //   Public Vars
  //
  //////////////////////////////////////////////////////////////////////

  self.settings = $.extend({
    $container: '',
    triggerSelector: '',
    contentSelectors: ''
  }, options);


  //
  //   Private Methods
  //
  //////////////////////////////////////////////////////////////////////

  const _init = function() {
    if (self.settings.$container.length < 1) return;

    _addEventListeners();
  };

  const _addEventListeners = function() {
    self.settings.$container.on('click', self.settings.triggerSelector, _toggle);
  };

  const _toggle = function(evt) {
    const $self = $(this); 
    const isOpen = $self.hasClass(self.activeClass);

    self.traverseCount = 0;

    self.settings.contentSelectors.forEach(function(selector, idx) {
      const el = _getSelector($self, selector); 
      if (el) _animateHeight(el, isOpen);
    });

    $self.toggleClass(self.activeClass, !isOpen);
  };

  const _animateHeight = function(el, isOpen) {
    const height = isOpen ? 0 : el.scrollHeight;

    $(el).animate({
      height: height
    }, self.transitionSpeed, function() {
      const $this = $(this);

      $(this)
        .toggleClass(self.activeClass, !isOpen)
        .css({
          'height': isOpen ? '' : 'auto'
        });
    });
  }

  const _getSelector = function($container, selectorStr) {
    let $el = $container.next(selectorStr);

    if ($el.length === 0) {
      // check is specific to markup dynamically output by Shopify's Bold Product Options app
      $el = $container.closest('.bold_option').find(selectorStr);
    } 

    return $el ? $el[0] : null;
  }

  //
  //   Initialize
  //
  //////////////////////////////////////////////////////////////////////

  _init();

  // Return the Object
  return self;
}
